// extracted by mini-css-extract-plugin
export var orderSummary = "_td-0";
export var showMoreLessButton = "_td-1";